import classnames from 'classnames';
import { CategoryLink as V3CategoryLink } from '@stadionhq-v3/base-ui';
import styles from './categoryLink.module.scss';
import { CategoryLinkProps } from './categoryLink.types';

export const CategoryLink = ({
  classNames,
  size = 'medium',
  ...props
}: CategoryLinkProps) => {
  const classes = classnames(
    [
      styles.tokens,
      styles.categoryLink,
      styles[size],
      {
        [`${styles.onDark}`]: props.onDark,
      },
    ],
    classNames
  );

  return <V3CategoryLink classNames={[classes]} {...props} />;
};
